import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
} from '@mui/material';

const JobStatusSummary = ({ jobs, activeJobs, maxConcurrent }) => {
    const completedToday = jobs.filter(job => 
        job.status === 'completed' && 
        new Date(job.completed_at).toDateString() === new Date().toDateString()
    ).length;

    const pendingJobs = jobs.filter(job => job.status === 'pending').length;

    return (
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} md={4}>
            <Card sx={{ bgcolor: 'primary.50' }} data-test-id="job-status-active">
              <CardContent>
                <Typography color="primary" variant="body2" gutterBottom>
                  Active Jobs
                </Typography>
                <Typography variant="h4" color="primary.dark" fontWeight="bold">
                  {activeJobs} / {maxConcurrent}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ bgcolor: 'success.50' }} data-test-id="job-status-completed-today">
              <CardContent>
                <Typography color="success.main" variant="body2" gutterBottom>
                  Completed Today
                </Typography>
                <Typography variant="h4" color="success.dark" fontWeight="bold">
                  {completedToday}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ bgcolor: 'warning.50' }} data-test-id="job-status-pending">
              <CardContent>
                <Typography color="warning.main" variant="body2" gutterBottom>
                  Pending Jobs
                </Typography>
                <Typography variant="h4" color="warning.dark" fontWeight="bold">
                  {pendingJobs}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
    );
};

export default JobStatusSummary;
